import http from '../utils/http';

export default {
    findByFiltro(filtro) {
        return http.get({
            url: '/clientes',
            data: filtro
        });
    },
    getAllParaguai() {
        return http.get({
            url: '/py/client/v1',
            lockScreen: false
        });
    }
};
